import React from 'react'
import ReactDOM from 'react-dom'

class Mirador extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var manifest = this.props.manifest
    var height = this.props.height
    return (
        <div className="mirador-embed-wrapper"><iframe width="100%" height={ height } src={ manifest } frameBorder="0" allow="autoplay; fullscreen; vr" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe></div>
    );
  }
}

export default Mirador



// WEBPACK FOOTER //
// ./src/components/Mirador.js